import { ReloadOutlined, SearchOutlined } from "@ant-design/icons";
import ActionHeader from "../../../components/ActionHeader";
import BaseTable from "../../../components/BaseTable";
import usePageState from "../../../hooks/usePageState";
import { useState } from "react";
import { RevenueResponse } from "../../../../infrastructure/model/OrderModel";
import { FilterRequest } from "../../../../applications/constants/AppTypes";
import {
  DATE_RANGE_OPTION_ENUM,
  ORDER_STATUS_ENUM,
} from "../../../../applications/constants/AppConst";
import useAsyncEffect from "../../../hooks/useAsyncEffect";
import { Button, Col, Tag } from "antd";
import Row from "../../../components/Row";
import { currencyFormat } from "../../../../applications/utils/NumberUtils";
import { useDateRangeSelector } from "../../../hooks/useDateRangeSelector";
import { getRevenueUseCase } from "../../../../applications/useCase/ApiUseCase/OrderApiUseCase";

interface RevenueProps {}

function Revenue(props: RevenueProps) {
  const { isLoading, setLoading, showError } = usePageState();
  const [dataTable, setDataTable] = useState<RevenueResponse>();

  const [total, setTotal] = useState<number>(0);
  const [filter, setFilter] = useState<FilterRequest>({
    page: 1,
    limit: 30,
  });
  const { startDate, endDate, DateRangeSelectorComponent, validateDateRange } =
    useDateRangeSelector({
      initSelectOptionDate: DATE_RANGE_OPTION_ENUM.TO_DAY,
    });

  async function getRevenueData() {
    if (!validateDateRange()) return;
    setDataTable(undefined);

    const res = await getRevenueUseCase({
      page: filter.page,
      limit: filter.limit,
      status: [ORDER_STATUS_ENUM.COMPLETE],
      startDate,
      endDate,
      showError,
      setLoading,
    });
    if (res) {
      setDataTable(res);
      setTotal(res.orders.total);
    }
  }

  useAsyncEffect(async () => {
    await getRevenueData();
  }, [filter]);

  return (
    <div className="h-100 flex flex-column">
      <ActionHeader
        rowCount={total}
        actions={[
          {
            icon: <ReloadOutlined />,
            isNormal: true,
            userClick: getRevenueData,
            type: "primary",
          },
        ]}
      />
      <Row className="gap-2" style={{ background: "white" }}>
        <Row
          className="gap-2 p-2"
          style={{
            display: "flex",
            alignItems: "end",
          }}
        >
          <DateRangeSelectorComponent />
          <Col>
            <Button
              icon={<SearchOutlined />}
              type="primary"
              onClick={getRevenueData}
              className="w-100"
            >
              Áp dụng
            </Button>
          </Col>
        </Row>
        <Row className="gap-3 flex align-items-center ">
          <Col className="mr-2">Số đơn hàng: {dataTable?.count_order.toLocaleString()}</Col>
          <Col className="mr-2" style={{ fontWeight: "bold", color: "#08F" }}>
            Tổng giá gốc: {dataTable?.original_price.toLocaleString()}
          </Col>
          <Col className="mr-2" style={{ fontWeight: "bold", color: "#08F" }}>
            Tổng giá bán: {dataTable?.price.toLocaleString()}
          </Col>
          <Col>Giảm tại quầy: {dataTable?.counter_discount.toLocaleString()}</Col>
        </Row>
      </Row>

      <div style={{ height: `calc(100% - 60px)` }}>
        <BaseTable
          dataSource={dataTable?.orders.data || []}
          loading={isLoading}
          columns={[
            {
              title: "ID",
              dataIndex: "id",
              key: "id",
              width: 100,
            },
            {
              title: "Mã đơn hàng",
              dataIndex: "code",
              key: "code",
            },
            {
              title: "Nguời đặt hàng",
              dataIndex: "username",
              key: "getAllOrders",
              width: 200,
            },
            {
              title: "Số điện thoại",
              dataIndex: "user_phone",
              key: "user_phone",
              width: 100,
            },
            {
              title: "Địa chỉ giao hàng",
              dataIndex: "address",
              key: "address",
              minWidth: 100,
            },
            {
              title: "Ghi chú",
              dataIndex: "order_note",
              key: "order_note",
              width: 200,
              minWidth: 100,
            },
            {
              title: "Giá tiền gốc",
              dataIndex: "original_price",
              key: "original_price",
              minWidth: 100,
              render(value) {
                return currencyFormat(value);
              },
            },
            {
              title: "Giá bán",
              dataIndex: "discount_price",
              key: "discount_price",
              minWidth: 100,
              render(value) {
                return currencyFormat(value);
              },
            },
            {
              title: "Giảm giá tại quầy",
              dataIndex: "counter_discount",
              key: "counter_discount",
              minWidth: 100,
              render(value) {
                return currencyFormat(value);
              },
            },
            {
              title: "Áp dụng KM",
              dataIndex: "apply_vouchers",
              key: "apply_vouchers",
              width: 300,
              minWidth: 200,
            },
            {
              title: "Trạng thái",
              dataIndex: "order_status",
              key: "order_status",
              width: 100,
              render(value) {
                return (
                  <Tag
                    color={
                      value === ORDER_STATUS_ENUM.NOT_CONFIRM
                        ? "warning"
                        : value === ORDER_STATUS_ENUM.APPROVE
                          ? "processing"
                          : value === ORDER_STATUS_ENUM.COMPLETE
                            ? "success"
                            : "error"
                    }
                  >
                    {ORDER_STATUS_ENUM?.[value]}
                  </Tag>
                );
              },
            },
          ]}
          rowKey={"id"}
          pagination={{
            total: total,
            current: filter.page,
            pageSize: filter.limit,
            onChange(page, pageSize) {
              setFilter({ ...filter, page: page, limit: pageSize });
            },
          }}
        />
      </div>
    </div>
  );
}
export default Revenue;
